import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

// token layer first (custom properties + reset), then shell, felt, and shared primitives.
import './styles/tokens.css';
import './styles/shell.css';
import './styles/felt.css';
import './styles/primitives.css';
import './styles/observe.css';
import './styles/diagnose.css';
import './styles/report.css';
import './styles/solo.css';
import './styles/progress.css';
import './styles/replay.css';
import './styles/live.css';
import './styles/home.css';
import './styles/tournament.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register the offline service worker (see public/sw.js). Wrapped so a failure never breaks the
// app, and skipped on the dev server (only the built origin serves /sw.js).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* offline support is best-effort; the app still runs without it */
    });
  });
}
